import styled from 'styled-components';
import { color } from '../../../../atoms/colors';
import { shadow } from '../../../../atoms/shadows';
import { font } from '../../../../atoms/typography';
import { spacing } from '../../../../atoms/spacing';

export const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  ${props => props.hidden && `display: none;`}
  ${({ styles }) => styles}
`;

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: ${({ layout }) => layout || 'column'};
  gap: ${spacing[6]};
`;

export const LabelContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing[8]};
`;

export const Label = styled.label`
  ${font('text', 'sm', '400')}
  color: ${color.darkBlue[700]};
  margin: ${spacing[0]};
`;

export const TooltipContainer = styled.div`
  cursor: pointer;
`;

export const Tooltip = styled.div`
  position: absolute;
  max-width: 300px;
  right: -8px;
  bottom: calc(100% + 12px);
  background-color: ${color.darkBlue[1000]};
  color: ${color.common.white};
  z-index: 1;
  padding: 12px;
  border-radius: 8px;
  ${font('text', 'xs', '400')}
  transition: all 250ms ease-in-out;

  &::before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid ${color.darkBlue[1000]};
    bottom: -6px;
    right: 6px;
    border-top-right-radius: 4px;
  }

  &.visible {
    opacity: 1;
    pointer-events: all;
  }

  &.hidden {
    opacity: 0;
    pointer-events: none;
  }
`;

export const Astericks = styled.span`
  width: 10px;
  height: 10px;
  ${font('text', 'sm', '700')}
  color: ${color.darkBlue[700]};
`;

export const SelectWrapper = styled.div`
  position: relative;
  width: 100%;

  &::after {
    content: '';
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    width: 21px;
    height: 20px;
    background: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none"><path d="M5.28516 7.5L10.2852 12.5L15.2852 7.5" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg>')
      no-repeat center;
    background-size: contain;
  }
`;

export const Select = styled.select`
  cursor: pointer;

  && {
    width: 100%;
    height: auto;
    padding: 8px 24px 8px 12px;
    margin: ${spacing[0]} ${spacing[0]} ${spacing[12]};
    border-radius: 8px;
    background: ${color.common.white};
    border: 1px solid ${color.darkBlue[100]};
    ${shadow('xs', 'dark')}
    ${font('text', 'sm', '400')}
    color: ${color.darkBlue[700]};
    transition: all 250ms ease-in-out;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;

    &:focus,
    &:hover {
      box-shadow: none;
    }

    &.error {
      border: 1px solid ${color.primary[1000]};
    }
  }

  &[type='checkbox'] {
    width: 20px;
    height: 20px;
  }
`;

export const ErrorIcon = styled.img`
  position: absolute;
  width: 20px;
  height: 20px;
  top: 54%;
  right: 42px;
`;

export const ErrorMessage = styled.div`
  transform: translateY(6px);
  ${font('text', 'sm', '400')}
  color: ${color.primary[1000]};
  p {
    ${font('text', 'sm', '400')}
    color: ${color.primary[1000]};
  }
  a {
    ${font('text', 'sm', '400')}
    color: ${color.blue[700]};
  }
`;
